import React, { useEffect, useState } from 'react';
import AuthCardContainer from '../Register/AuthCardContent';
import { Box, Typography } from '@mui/material';
import { CustomButton, TextField } from '../../../v2/MUI_custom_component';
import BoxInput from '../../Common/BoxInput/BoxInput';
import HumbeeTabs from '../../../v2/MUI_custom_component/Tab';
import { MOBILE_REGEX, EPIN_REGEX } from '../Register/Components/regex';
import { encryptPassword } from '../../../v2/Utils/Encryption/NodeForgeEncryption';
import { onLoggedIn } from '../../../v2/Function/onLoggedIn';
import { useNavigate } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { toast } from 'react-toastify';
import IconReusable from '../../../components/IconReusable';
import { sendOTPAction } from '../Register/API/Action';
import { LOGIN_METHOD_ENUM, OTP_PURPOSE_ENUM } from '../Enum';
import { LoginAction } from './API/Action';
import { validateMobile } from '../../Common/Validation/mobileValidation';

const Login = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [mobile, setMobile] = useState('');
  const [epin, setEpin] = useState('');
  const [otp, setOtp] = useState('');
  const [mobileErr, setMobileErr] = useState('');
  const [epinErr, setEpinErr] = useState('');
  const [loading, setLoading] = useState(false);
  const [apiError, setApiError] = useState('');
  const [tab, setTab] = useState(0);
  const EPIN_SET = useSelector((state) => state.authReducer.EPIN_SET);
  const USER_DATA_FILLED = useSelector(state => state.authReducer.USER_DATA_FILLED);

  const tabs = [
    { label: 'e-Pin', value: LOGIN_METHOD_ENUM.EPIN },
    { label: 'OTP', value: LOGIN_METHOD_ENUM.OTP }
  ];
  const handleTabChange = (e, newTab) => {
    const selectedTab = tabs[newTab].value;
    dispatch({ type: 'SET_LOGIN_METHOD', payload: selectedTab });
    setApiError('');
    setTab(newTab);
    setMobile('');
    setEpin('');
    setOtp('');
    setMobileErr('');
    setEpinErr('');
  };

  const handleRedirection = (epinSet = EPIN_SET, userDataFilled = USER_DATA_FILLED) => {
      if (!epinSet) {
        navigate('/epin');
      }else if (!userDataFilled) {
          navigate('/user-details');
      } else { 
          navigate('/');
      }
  }
  const handleEpinLogin = async () => {
    let valid = true;

    if (!MOBILE_REGEX.test(mobile)) {
      setMobileErr('Enter valid 10-digit mobile number');
      valid = false;
    } else {
      setMobileErr('');
    }

    if (!EPIN_REGEX.test(epin)) {
      setEpinErr('Enter valid 6-digit e-Pin');
      valid = false;
    } else {
      setEpinErr('');
    }

    if (!valid) return;

    setLoading(true);
    const encryptedMobile = encryptPassword(mobile);
    const encryptedEpin = encryptPassword(epin);
    const payload = {
      mobile_number: encryptedMobile,
      epin: encryptedEpin,
      method: LOGIN_METHOD_ENUM.EPIN
    };

    const { data, error, message } = await LoginAction(payload);
    setLoading(false);
    if (!error) {
      localStorage.setItem('token', data.token);
      dispatch({ type: 'SET_USER_DATA_FILLED', payload: data.user_data_filled });
      dispatch({ type: 'SET_EPIN_SET', payload: data.is_epin_set });
      if(data?.user_data_filled === true && data?.is_epin_set === true){
        await onLoggedIn({
            data: {
                token: data.token
            },
            navigate,
            dispatch,
            toast
        });
      }
      handleRedirection(data.is_epin_set, data.user_data_filled);
    } else {
      setApiError(message || 'Login failed. Please try again.');
    }
  };
  
  const handleNewAccount = () => {
    dispatch({ type: 'SET_OTP_PURPOSE', payload: OTP_PURPOSE_ENUM.REGISTER });
    navigate('/registration');
  };
  const handleForgetEpin = () => {
    dispatch({ type: 'SET_OTP_PURPOSE', payload: OTP_PURPOSE_ENUM.RESET });
    navigate('/reset-pin');
  };
  const handleSendOtp = async () => {
    const mobileValidation = validateMobile(mobile);
    if (!mobileValidation.valid) {
      setMobileErr(mobileValidation.message);
      return;
    }
    setLoading(true);
    const encryptedMobile = encryptPassword(mobile);
    const payload = { 
        mobile_number: encryptedMobile,
        purpose: OTP_PURPOSE_ENUM.LOGIN
    };
    const { error, message } = await sendOTPAction(payload);
    setLoading(false);
    if (!error) {
        dispatch({ type: 'SET_MOBILE', payload: encryptedMobile });
        navigate('/otp', {state: { mobile_no: mobile }});
    } else {
        setApiError(message);
    }
  };

  useEffect(() => {
    dispatch({ type: 'LOGOUT' });
    dispatch({ type: 'RESET_AUTH'});
    dispatch({ type: 'RESET_FIRM_ONBOARDING_REDUCER'});
    dispatch({ type: 'SET_OTP_PURPOSE', payload: OTP_PURPOSE_ENUM.LOGIN });
  }, []);

  const isEPinFormValid = MOBILE_REGEX.test(mobile) && EPIN_REGEX.test(epin);
  const isOTPFormValid = MOBILE_REGEX.test(mobile)

  return (
    <AuthCardContainer>
      <Box sx={{ display: "flex", flexDirection: "column", gap: 4 }}>
        <Typography variant='h1' sx={{ color: '#666666' }}>Login</Typography>
        <HumbeeTabs
          tabType="standard"
          data={tabs}
          currentTab={tab}
          onChange={handleTabChange}
          getTabLabel={item => item.label}
          renderTabContent={(item, idx) => {
            if (item.value === LOGIN_METHOD_ENUM.EPIN ) {
              return (
                <Box sx={{ display: 'flex', flexDirection: 'column', gap: 4 }}>
                  <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
                    <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1 }}>
                      <TextField
                        label="Mobile Number*"
                        value={mobile}
                        onChange={e => setMobile(e.target.value.replace(/\D/g, '').slice(0, 10))}
                        placeholder="Enter Mobile number"
                        error={!!mobileErr}
                      />
                      {mobileErr && 
                        <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.5 }}>
                          <IconReusable name="ErrorFilled" size={20} color="#CC0000" />
                          <Typography variant="body2" sx={{ color: '#CC0000' }}>{mobileErr}</Typography> 
                        </Box>
                      } 
                    </Box>
                    <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1 }}>
                      <BoxInput
                        label="Enter e-Pin*"
                        length={6}
                        value={epin}
                        onChange={setEpin}
                        type="password"
                        showEyeIcon={true}
                        error={!!epinErr}
                      />
                      {epinErr && 
                        <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.5 }}>
                          <IconReusable name="ErrorFilled" size={20} color="#CC0000" />
                          <Typography variant="body2" sx={{ color: '#CC0000'}}>{epinErr}</Typography> 
                        </Box>
                      }
                    </Box>
                    {apiError && (
                      <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.5 }}>
                        <IconReusable name="ErrorFilled" size={20} color="#CC0000" />
                        <Typography variant='body1' sx={{ color: '#CC0000', }}>
                          {apiError}
                        </Typography>
                      </Box>
                    )}
                  </Box>
                  
                  <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1 }}>
                    <CustomButton
                      variant="filled"
                      label={'Login'}
                      loading={loading }
                      disabled={loading || !isEPinFormValid}
                      fullWidth
                      onClick={handleEpinLogin}
                    />
                    <CustomButton
                      variant="text"
                      color='neutral'
                      label={'Forgot e-Pin'}
                      fullWidth
                      onClick={handleForgetEpin}
                    />
                  </Box>
                </Box>
              );
            }
            if (item.value === LOGIN_METHOD_ENUM.OTP) {
              return (
                <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
                  <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1 }}>
                    <TextField
                      label="Mobile Number*"
                      value={mobile}
                      onChange={e => setMobile(e.target.value.replace(/\D/g, '').slice(0, 10))}
                      placeholder="Enter Mobile number"
                      error={!!mobileErr}
                      helperText={mobileErr}
                    />
                    {mobileErr && <Typography variant="body2" sx={{ color: '#CC0000', minHeight: 20 }}>{mobileErr}</Typography> } 
                    {apiError && (
                      <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.5 }}>
                        <IconReusable name="ErrorFilled" size={20} color="#CC0000" />
                        <Typography variant='body1' sx={{ color: '#CC0000', }}>
                          {apiError}
                        </Typography>
                      </Box>
                    )}
                  </Box>
                  <CustomButton
                    variant="filled"
                    disabled={loading || !isOTPFormValid}
                    label={'Send OTP'}
                    fullWidth
                    onClick={handleSendOtp}
                  />
                </Box>
              );
            }
            return null;
          }}
        />
        <CustomButton
          variant="outlined"
          label={'Create new account'}
          fullWidth
          onClick={handleNewAccount}
        />
      </Box>
    </AuthCardContainer>
  );
}

export default Login
